import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { GiftOffer, Permission } from "types";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { GiftOfferList } from "../../components/Product/GiftOfferList";
import { ProductSearch } from "../../components/Product/ProductSearch";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { Page } from "../Page";
import { IsGranted } from "@/components/Common/IsGranted";
import { SecondaryButton } from "@/components/Common/SecondaryButton";

export const GiftOfferListPage = () => {
    const [search, setSearch] = useState("");
    const { data: giftOffers, isLoading } = useAutoFetchCollection<GiftOffer>("giftOffers", { expand: "purchaseRule" });
    let filtered = useSearch(giftOffers, (giftOffer) => [giftOffer.name], search);
    filtered = orderBy(filtered, (gift) => gift.name, ["asc"]);
    const isFiltered = search.length > 0;
    const history = useHistory();

    const handleButtonClick = () => {
        history.push("/products/giftOffers/create");
    };

    const handleGlobalSettingsClick = () => {
        history.push("/products/gifts/globalSettings");
    };

    return (
        <Page title="Gifts">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Gifts</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ProductSearch onSearch={setSearch} />

                    <IsGranted permissions={Permission.PREFERENCES_GIFT_VIEW}>
                        <SecondaryButton className="flex-shrink-0" onClick={handleGlobalSettingsClick}>
                            Global Settings
                        </SecondaryButton>
                    </IsGranted>
                    <Button color="primary" className="flex-shrink-0" icon={<PlusIcon />} onClick={handleButtonClick}>
                        Create Gift
                    </Button>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <GiftOfferList giftOffers={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
